import { denormalize } from "normalizr";

import { getEntities } from "./entities";
import { serviceSchema } from "../schemas";

export const DEFAULT_MODIFICATION = "form";

export function getService(state, id) {
  return denormalize(id, serviceSchema, getEntities(state));
}
